import { useGlobalState } from "@services/useGlobalState";

export const useInEditorDomain = (): boolean => {
  const { inEditorDomain } = useGlobalState();

  return inEditorDomain;
};
